/**
 * PLC control-coverage roll-up for a `:Line` and its entire
 * `HAS_SUBLINE*0..` subtree (`$lineId` param). Powers the "Control
 * coverage" section of the Line detail page.
 *
 * Returned as a flat `lines` list of:
 *   - `id`, `name`, `lineCode`  — line identity
 *   - `parentId`                — the immediate `:Line` parent
 *                                 inside the same subtree, if any
 *                                 (used to stitch the flat list
 *                                 back into a tree client-side)
 *   - `isRoot`                  — true for the `$lineId` row, so
 *                                 the client can pick the root
 *                                 without comparing ids
 *   - `controllers`             — every `:Controller` the line
 *                                 itself is `CONTROLLED_BY`
 *   - `equipment[]`             — for each `:Equipment` on the line,
 *                                 its identity + the controllers
 *                                 that equipment is `CONTROLLED_BY`
 *
 * Bounded by `LIMIT 10000`.
 */
export const PLANT_LINE_CONTROL_COVERAGE_CYPHER = `
            MATCH (root:Line {id: $lineId})
            OPTIONAL MATCH (root)-[:HAS_SUBLINE*0..]->(line:Line)
            WITH root, collect(DISTINCT line) AS lines
            UNWIND lines AS line
            OPTIONAL MATCH (parent:Line)-[:HAS_SUBLINE]->(line)
              WHERE parent IN lines
            OPTIONAL MATCH (line)-[:CONTROLLED_BY]->(lc:Controller)
            WITH root, line, parent, collect(DISTINCT lc) AS lineControllers
            OPTIONAL MATCH (line)-[:HAS_EQUIPMENT]->(eq:Equipment)
            OPTIONAL MATCH (eq)-[:CONTROLLED_BY]->(ec:Controller)
            WITH root, line, parent, lineControllers, eq, collect(DISTINCT ec) AS eqControllers
            WITH root, line, parent, lineControllers,
                 collect(DISTINCT CASE WHEN eq IS NULL THEN NULL ELSE {
                   id: eq.id,
                   name: eq.name,
                   type: eq.equipment_type,
                   controllers: eqControllers
                 } END) AS equipment
            RETURN collect(DISTINCT {
              id: line.id,
              name: line.name,
              lineCode: line.line_code,
              parentId: parent.id,
              isRoot: line = root,
              controllers: lineControllers,
              equipment: [e IN equipment WHERE e IS NOT NULL]
            }) AS lines
            LIMIT 10000
          `
